// extracted by mini-css-extract-plugin
module.exports = {"Main":"PageNotFound_Main__2S-UC","Box":"PageNotFound_Box__2Hs2d","P":"PageNotFound_P__7NE09"};